/* lt-app.js — Laser Tags v2 */
(function () {
  if (window.__ltInit) return; window.__ltInit = true;

  function money(cents) {
    var fmt = (window.LT && window.LT.moneyFormat) || '${{amount}}';
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, parts.join('.'));
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lt-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initGallery(g) {
    var slides = g.querySelectorAll('.lt-slide'), thumbs = g.querySelectorAll('.lt-thumb'), dots = g.querySelectorAll('.lt-dots i'), i = 0;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        var v = s.querySelector('video'); if (v) { k === i ? v.play().catch(function () {}) : v.pause(); }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = g.querySelector('.lt-stage-nav--prev'), n = g.querySelector('.lt-stage-nav--next');
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (n) n.addEventListener('click', function () { go(i + 1); });
    var sx = null, st = g.querySelector('.lt-stage');
    st.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    st.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 35) go(dx < 0 ? i + 1 : i - 1);
      sx = null;
    });
    g.__ltGo = function (id) { slides.forEach(function (s, k) { if (s.dataset.mediaId === String(id)) go(k); }); };
  }

  function after(form) { var w = form.closest('[data-after]'); return w ? w.dataset.after : 'checkout'; }

  function addToCart(items, btn, dest) {
    if (btn) btn.classList.add('is-loading');
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = dest === 'cart' ? '/cart' : '/checkout'; })
      .catch(function () { window.location.href = '/cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(','); });
  }

  function formItems(form) {
    var id = form.querySelector('input[name="id"]').value;
    var q = parseInt((form.querySelector('[data-lt-qty]') || {}).value, 10) || 1;
    var items = [{ id: parseInt(id, 10), quantity: q }];
    var sel = form.querySelector('[data-lt-tier].is-selected');
    if (sel) sel.querySelectorAll('[data-lt-addon]:checked').forEach(function (c) { items.push({ id: parseInt(c.value, 10), quantity: 1 }); });
    return items;
  }

  function initBuy(form) {
    var idInput = form.querySelector('input[name="id"]');
    var qty = form.querySelector('[data-lt-qty]');
    var tiers = form.querySelectorAll('[data-lt-tier]');
    var gallery = document.querySelector('.lt-gallery');

    function select(t) {
      tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t); });
      var r = t.querySelector('input[type="radio"]'); if (r) r.checked = true;
      idInput.value = t.dataset.variantId;
      var q = parseInt(t.dataset.qty, 10) || 1;
      if (qty) qty.value = q;
      var price = parseInt(t.dataset.price, 10) * q, cmp = parseInt(t.dataset.compare, 10) * q;
      document.querySelectorAll('[data-lt-btn-price]').forEach(function (el) { el.textContent = money(price); });
      document.querySelectorAll('[data-lt-sticky-name]').forEach(function (el) { el.textContent = t.dataset.name; });
      document.querySelectorAll('[data-lt-sticky-price]').forEach(function (el) { el.textContent = money(price); });
      document.querySelectorAll('[data-lt-sticky-compare]').forEach(function (el) { el.textContent = cmp > price ? money(cmp) : ''; });
      if (t.dataset.mediaId && gallery && gallery.__ltGo) gallery.__ltGo(t.dataset.mediaId);
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.target.closest('.lt-bx-addon')) return;
        e.preventDefault(); select(t);
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(formItems(form), form.querySelector('[data-lt-submit]'), after(form));
    });
    var s = (location.search.indexOf('variant=') === -1 && form.querySelector('[data-lt-tier][data-popular="true"]')) || form.querySelector('[data-lt-tier].is-selected') || tiers[0]; if (s) select(s);
  }

  function initSticky() {
    var s = document.querySelector('.lt-sticky'), anchor = document.querySelector('[data-lt-buy-anchor]');
    if (s && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; s.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(anchor);
    }
    document.querySelectorAll('[data-lt-buy-now]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var form = document.querySelector('form.lt-form');
        if (b.dataset.ltBuyNow === 'scroll' || !form) {
          var t = document.getElementById('lt-buy');
          if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          return;
        }
        e.preventDefault();
        addToCart(formItems(form), b, after(form));
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-lt-faq]').forEach(function (list) {
      var ds = list.querySelectorAll('details');
      ds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
    });
  }

  function boot() {
    initReveal(); initFaq();
    document.querySelectorAll('.lt-gallery').forEach(initGallery);
    document.querySelectorAll('form.lt-form').forEach(initBuy);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.lt-reveal').forEach(function (x) { x.classList.add('is-in'); }); });
})();
